import React, {useCallback, useState} from "react";
import axios from "axios";

const initialData = [];

const initialColumns = [];

const initialStatus = {
  loading: false,
  error: null
};

const loadingStatus = {
  loading: true,
  error: null
};

const loadedStatus = {
  loading: false,
  error: null
};

const errorStatus = (msg) => ({
  loading: false,
  error: msg
});

export default function useQuery(id) {
  const [data, setData] = useState(initialData);
  const [columns, setColumns] = useState(initialColumns);
  const [name, setName] = useState("Реестр");
  const [status, setStatus] = useState(initialStatus);

  const load = useCallback(() => {
    setStatus(loadingStatus);
    return axios.get(`/work/api/query/${id}?withMeta=true`, {
      headers: {
        'Accept': 'application/json'
      }
    }).then(response => {
      let dataWithMeta = response.data;
      setColumns(dataWithMeta.columns || []);
      setData(dataWithMeta.data || []);
      setName(dataWithMeta.name || "Реестр " + id);
      setStatus(loadedStatus);
    }).catch(() => {
      setData([]);
      setColumns([]);
      setName("Реестр " + id);
      setStatus(errorStatus("При загрузке произошла ошибка"));
    })
  }, [id]);

  const refresh = useCallback(() => {
    setStatus(loadingStatus);
    return axios.get(`/work/api/query/${id}?withMeta=false`, {
      headers: {
        'Accept': 'application/json'
      }
    }).then(response => {
      setData(response.data.data || []);
      setStatus(loadedStatus);
    }).catch(() => {
      setData([]);
      setStatus(errorStatus("При загрузке произошла ошибка"));
    })
  }, []);
  return {name, data, columns, status, load, refresh};
}
